var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "title-section",
      class: _vm.background,
      style: _vm.getStyle()
    },
    [
      _c("div", { staticClass: "title-main" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-10" }, [
              _c("h1", { staticClass: "p-white p-title relawayBold" }, [
                _vm._v(
                  "Find the best and cheapest electricity deal in Stockholm"
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "breadcrumbs" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("span", { staticClass: "separator" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "8",
                        height: "12",
                        viewBox: "0 0 8 12",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        style: _vm.GetSvgStyle(),
                        attrs: {
                          "stroke-width": "0.2",
                          d:
                            "M1.39614 11.1C1.52503 11.1 1.64589 11.0577 1.7429 10.9712L6.95063 6.32462C7.14979 6.14692 7.14979 5.85308 6.95063 5.67538L1.7429 1.02883C1.55038 0.857056 1.24189 0.857056 1.04937 1.02883C0.850211 1.20653 0.850211 1.50037 1.04937 1.67806L5.89327 6L1.04937 10.3219C0.850211 10.4996 0.850211 10.7935 1.04937 10.9712C1.14638 11.0577 1.26724 11.1 1.39614 11.1Z"
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("span", { staticClass: "separator" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "8",
                        height: "12",
                        viewBox: "0 0 8 12",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        style: _vm.GetSvgStyle(),
                        attrs: {
                          "stroke-width": "0.2",
                          d:
                            "M1.39614 11.1C1.52503 11.1 1.64589 11.0577 1.7429 10.9712L6.95063 6.32462C7.14979 6.14692 7.14979 5.85308 6.95063 5.67538L1.7429 1.02883C1.55038 0.857056 1.24189 0.857056 1.04937 1.02883C0.850211 1.20653 0.850211 1.50037 1.04937 1.67806L5.89327 6L1.04937 10.3219C0.850211 10.4996 0.850211 10.7935 1.04937 10.9712C1.14638 11.0577 1.26724 11.1 1.39614 11.1Z"
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("span", [_vm._v("Some page name")])
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("a", { attrs: { href: "#" } }, [
        _vm._v(
          "\n                                Home\n                            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("a", { attrs: { href: "#" } }, [
        _vm._v(
          "\n                                Home2\n                            "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }